import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScheduleValuesComponent } from './schedule-values.component';

const routes: Routes = [
  {
    path: '',
    component: ScheduleValuesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScheduleValuesRoutingModule { }
